import React from "react"
import propTypes from "prop-types"
import IdleTimer from "react-idle-timer"

const IdleTimeout = ({ onSignOut }) => {
  return (
    <IdleTimer timeout={1000 * 60 * 15} onIdle={onSignOut} debounce={250} />
  )
}

IdleTimeout.propTypes = {
  onSignOut: propTypes.func.isRequired
}

export default IdleTimeout
